<template>
  <v-container>
    <div class="title">Metrics QA</div>
    <v-card class="ma-3 pa-3">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-text-field outlined class="ma-3" label="deckId" v-model="deckId"></v-text-field>

        </v-flex>
        <v-flex x12 sm6>
          <v-text-field outlined class="ma-3" label="uid" v-model="uid"></v-text-field>
        </v-flex>

      </v-layout>
      <v-btn @click="subscribeToMetrics">Subscribe to Metrics</v-btn>

      <v-row v-if="deckDataHistory.length > 0">
        <v-flex xs4 v-for="(item, index) in dataHistory" :key="index">
          <v-card class="pa-2">
            <div class="orange--text">{{item.name}}</div>
            <div class="title blue--text">Core Metrics</div>
            <div v-if="item.deck.currentSession">
              <div><span class="overline">History Length:  </span>{{item.deck.currentSession.deckMetrics.answerHistory.length}}</div>
              <div><span class="overline">Assess True:  </span>{{item.deck.currentSession.deckMetrics.assessTrue}}</div>
              <div><span class="overline">Assess False:  </span>{{item.deck.currentSession.deckMetrics.assessFalse}}</div>
              <div><span class="overline">Assess Time:  </span>{{prettyDate(item.deck.currentSession.deckMetrics.timeAssess)}}</div>
              <div><span class="overline">Learn Time:  </span>{{prettyDate(item.deck.currentSession.deckMetrics.timeLearn)}}</div>
              <div><span class="overline">Review Time:  </span>{{prettyDate(item.deck.currentSession.deckMetrics.timeReview)}}</div>
              <div><span class="overline">Complete Time:  </span>{{prettyDate(item.deck.currentSession.deckMetrics.timeComplete)}}</div>
            </div>

          </v-card>
          <v-card class="pa-2">
            <div class="title blue--text">Deck JSON</div>
            <VueJsonPretty path='res' :data="item.deck" :showDoubleQuotes='false' :showLength='true' :deep='1' :highlightMouseoverNode='true'/>
          </v-card>
          <v-card class="pa-2">
            <div class="title blue--text">Card JSON</div>
            <VueJsonPretty path='res' :data="item.cards" :showDoubleQuotes='false' :showLength='true' :deep='2' :highlightMouseoverNode='true'/>
          </v-card>
        </v-flex>

        </v-flex>
      </v-row>





    </v-card>
  </v-container>

</template>

<script>
import firebase from 'firebase'
import VueJsonPretty from 'vue-json-pretty'
import moment from 'moment'

export default {
  name: 'QAMetrics',
  components: {
    VueJsonPretty
  },
  data() {
    return {
      counterKey: 0,
      view: [0, 1],
      view1: 0,
      view2: 0,
      deckId: 'Kzm4PAZX3EzZYB1VzFLk',
      uid: 'HSt6S2N9qHaG4sR2Uy6pYTMng123',
      deckData: null,
      cardsData: null,
      deckDataHistory: [],
      cardsDataHistory: []


    }
  },
  computed: {
    dataHistory() {
      let length = this.deckDataHistory.length
      if (length == 1) {
        return [
          {name: 'last', deck: this.deckDataHistory[length - 1], cards: this.cardsDataHistory[length - 1]}
        ]

      }
      else if (length == 2) {
        return [
          {name: 'last', deck: this.deckDataHistory[length - 1], cards: this.cardsDataHistory[length - 1]},
          {name: 'two back', deck: this.deckDataHistory[length - 2], cards: this.cardsDataHistory[length - 2]}
        ]

      }
      else if (length > 2) {
        return [
          {name: 'last', deck: this.deckDataHistory[length - 1], cards: this.cardsDataHistory[length - 1]},
          {name: 'two back', deck: this.deckDataHistory[length - 2], cards: this.cardsDataHistory[length - 2]},
          {name: 'three back', deck: this.deckDataHistory[length - 3], cards: this.cardsDataHistory[length - 3]}

        ]

      }
      else {
        return []
      }
    }
  },
  methods: {
    prettyDate(d) {
      if (d != null) {
        return moment(d.toDate()).format('MM-DD HH:mm:ss')
      }
      else return 'not yet set'

    },
    subscribeToMetrics() {
      this.deckDataHistory = []
      this.cardsDataHistory = []

      firebase.firestore()
      .collection('learningRecord')
      .doc(this.uid)
      .collection('deckRecord')
      .doc(this.deckId)
      .onSnapshot(doc => {
        this.deckData = doc.data()
        this.deckDataHistory.push(this.deckData)
      })


      firebase.firestore()
      .collection('learningRecord')
      .doc(this.uid)
      .collection('cardRecord')
      .onSnapshot(snapshot => {
        this.cardData = []
        snapshot.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.cardData.push(data)
        })
        this.cardsDataHistory.push(this.cardData)
        this.counterKey += 1 //triger component rerender
      })

    }
  }
}

</script>
